import React, { useState } from "react";
import "./../comparativeAnalysis.less";

const dataModes = [
  { value: "molarFraction", label: "摩尔分率" }, // 新增
  { value: "massFlow", label: "质量流量（kg/h）" },
  { value: "molarFlow", label: "摩尔流量（mol/h）" },
  { value: "massConcentration", label: "质量浓度 (mg/m³)" },
];

// 需要显示的组分
const FILTERED = ["水", "甲醇", "一氧化碳", "二氧化碳", "甲烷", "氢气", "氮气"];

export default function StreamsComponentTable({ multiResults, materials, transInputs }: any) {
  const [dataMode, setDataMode] = useState("molarFraction");
  const safe = (v: any) => (v == null || isNaN(v)) ? "0" : Number(v).toFixed(2);

  // ====================== 生成单行数据（流股 + 任务 → 一行） ======================
  const getComponentRow = (stream: any, task: any) => {
    const row: string[] = [];

    // 1. 流股名 + 任务名（和工艺表格式一样）
    row.push(`${stream.name}_任务${task.taskId}`);

    // 2. 逐个组分计算数值
    materials?.forEach((m: any, idx: number) => {
      // if (!FILTERED.includes(m.Name_ZH)) return;

      const mf = stream.mass_frac?.[idx] || 0;
      const mof = stream.molar_frac?.[idx] || 0;
      const fkg = stream.f_kg_per_h || 0;
      const fmol = stream.f_mol_per_h || 0;
      const fnm3 = stream.f_nm3_per_h || 1;

      let v = 0;
      switch (dataMode) {
        case "massFlow": v = fkg * mf; break;
        case "molarFlow": v = fmol * mof; break;
        case "massConcentration": v = (fkg * 1e6 * mf) / fnm3; break;
        case "molarFraction": v = mof; break; // 新增
      }
      row.push(safe(v));
    });

    return row;
  };

  // ====================== 生成全部表格数据 ======================
  const generateTableData = (type: "inputStreams" | "outStreams") => {
    if (!multiResults || multiResults.length === 0) return [];

    const allRows: any[] = [];
    const firstTask = multiResults[0];
    const baseStreams = firstTask[type] || [];

    // 遍历每个流股
    baseStreams.forEach((stream: any, streamIndex: number) => {
      // 遍历每个任务
      multiResults.forEach((task: any) => {
        const targetStream = task[type]?.[streamIndex];
        if (targetStream) {
          allRows.push(getComponentRow(targetStream, task));
        }
      });
    });

    return allRows;
  };

  // ====================== 统一静态表头（只出现一次） ======================
  const getComponentHeaders = () => {
    const headers = ["流股"];
    materials?.forEach((m: any) => {
      // if (FILTERED.includes(m.Name_ZH)) {
        headers.push(m.Molecular_formula || m.Name_ZH);
      // }
    });
    return headers;
  };

  const inputRows = generateTableData("inputStreams");
  const outputRows = generateTableData("outStreams");
  const tableHeaders = getComponentHeaders();

  return (
    <div className="steams-component-table-container">
      <div className="mode-selector-container">
        <span className="mode-selector-label">显示模式：</span>
        <div className="mode-buttons">
          {dataModes.map(m => (
            <button
              key={m.value}
              className={`mode-button ${dataMode === m.value ? "active" : ""}`}
              onClick={() => setDataMode(m.value)}>
              {m.label}
            </button>
          ))}
        </div>
      </div>

      <div className="table-container">
        <h3 className="stream-title">输入流股组分</h3>
        <div className="table-wrapper">
          <table className="component-data-table">
            <thead>
              <tr className="table-header">
                {tableHeaders.map((h, i) => (
                  <th key={i} className="table-header-cell">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {inputRows.length > 0 ? (
                inputRows.map((row, i) => (
                  <tr key={i} className="table-row">
                    {row.map((cell, j) => (
                      <td key={j} className="table-cell">{cell}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr className="empty-row">
                  <td colSpan={tableHeaders.length} className="empty-cell">暂无数据</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <h3 className="stream-title">输出流股组分</h3>
        <div className="table-wrapper">
          <table className="component-data-table">
            <thead>
              <tr className="table-header">
                {tableHeaders.map((h, i) => (
                  <th key={i} className="table-header-cell">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {outputRows.length > 0 ? (
                outputRows.map((row, i) => (
                  <tr key={i} className="table-row">
                    {row.map((cell, j) => (
                      <td key={j} className="table-cell">{cell}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr className="empty-row">
                  <td colSpan={tableHeaders.length} className="empty-cell">暂无数据</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}